module.exports = __webpack_public_path__ + "static/media/Group 25119.305f8976.svg";